import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-navigation-overflow-expand': {
    'en-US': 'see more',
    'ar-AE': 'اطلع على المزيد',
    'bn-IN': 'আরও দেখুন',
    'de-DE': 'mehr anzeigen',
    'es-ES': 'mostrar más',
    'es-MX': 'ver más',
    'fr-BE': 'voir plus',
    'fr-FR': 'en savoir plus',
    'gu-IN': 'વધુ જુઓ',
    'hi-IN': 'ज़्यादा देखें',
    'it-IT': 'mostra altro',
    'ja-JP': 'さらに表示',
    'kn-IN': 'ಇನ್ನಷ್ಟು ನೋಡಿ',
    'ko-KR': '더 보기',
    'ml-IN': 'കൂടുതൽ കാണുക',
    'mr-IN': 'अधिक पहा',
    'nl-BE': 'meer bekijken',
    'nl-NL': 'meer bekijken',
    'pl-PL': 'wyświetl więcej',
    'pt-BR': 'ver mais',
    'pt-PT': 'ver mais',
    'sv-SE': 'läs mer',
    'ta-IN': 'மேலும் காண்க',
    'te-IN': 'మరిన్ని చూడండి',
    'th-TH': 'ดูเพิ่มเติม',
    'tr-TR': 'daha fazla',
    'vi-VN': 'xem thêm',
    'zh-CN': '查看更多',
    'zh-TW': '查看更多',
  },
};

export default katTranslator(strings);
